import React from 'react';
import UnAuthorizedPage from './UnAuthorizedPage';
import InviteUserContainer from '../containers/InviteUserContainer';
import translate from '../lib/i18n/translate'

const InviteUserPage = () => {
    return (
        <UnAuthorizedPage>
            <InviteUserContainer/>
        </UnAuthorizedPage>
    );
}

export default translate('InviteUserForm')(InviteUserPage);




// WEBPACK FOOTER //
// ./src/pages/InviteUserPage.js